import React from 'react';
import { Card, Tooltip, message } from 'antd';
import { DeleteOutlined, EditOutlined, EyeOutlined } from "@ant-design/icons";
import { Kanban } from '../Kanban/Kanban.jsx';
import { canEditVacancy, canChangeVacancyStatus } from '../../utils/vacancyPermissions';

const KanbanView = ({
  vacancies,
  onView,
  onEdit,
  onDelete,
  organisations,
  users,
  onStatusChange,
  STATUSES,
  selectedStatuses,
  userRole = null
}) => {
  const { canEdit: hasEditPermission } = canEditVacancy(userRole);
  const canChangeStatus = canChangeVacancyStatus(userRole);
  
  const getEntityName = (id, entities) => {
    const entity = entities.find(e => e.organisation_id == id);
    return entity ? entity.name : 'Не указано';
  };

  const getDepartmentName = (departmentId, organisationId) => {
    const organisation = organisations.find(org => org.organisation_id == organisationId);
    if (organisation && organisation.departments) {
      const department = organisation.departments.find(dept => dept.id === departmentId);
      return department ? department.name : 'Не указано';
    }
    return 'Не указано';
  };

  const getUserName = (id) => {
    const user = users.find(u => u.id === id);
    return user ? `${user.first_name} ${user.last_name}` : 'Не указано';
  };

  const renderCard = (vacancy) => (
    <Card
      key={vacancy.id}
      size="small"
      style={{ marginBottom: '8px' }}
      actions={[
        <Tooltip title="Просмотреть вакансию">
          <EyeOutlined key="view" onClick={() => onView(vacancy)} />
        </Tooltip>,
        <Tooltip title={hasEditPermission ? "Редактировать вакансию" : "У вас нет прав для редактирования вакансии"}>
          <EditOutlined
            key="edit"
            onClick={() => hasEditPermission ? onEdit(vacancy) : null}
            style={{
              color: hasEditPermission ? undefined : '#d9d9d9',
              cursor: hasEditPermission ? 'pointer' : 'not-allowed'
            }}
          />
        </Tooltip>,
        <Tooltip title={
          !hasEditPermission ? "У вас нет прав для удаления вакансии" :
            vacancy.is_template ? "Удалить вакансию" :
              "Удаление доступно только для черновиков"
        }>
          <DeleteOutlined
            key="delete"
            onClick={() => (vacancy.is_template && hasEditPermission) ? onDelete(vacancy.id) : null}
            style={{
              color: (vacancy.is_template && hasEditPermission) ? undefined : '#d9d9d9',
              cursor: (vacancy.is_template && hasEditPermission) ? 'pointer' : 'not-allowed'
            }}
          />
        </Tooltip>,
      ]}
    >
      <p>ID: {vacancy.id}</p>
      <p>Должность: {vacancy.job_title}</p>
      <p>Компания: {vacancy.organisation_name || getEntityName(vacancy.organisation_id, organisations)}</p>
      <p>Отдел: {vacancy.department_name || getDepartmentName(vacancy.department_id, vacancy.organisation_id)}</p>
      <p>Рекрутер: {getUserName(vacancy.assigner_id)}</p>
    </Card>
  );

  const handleDragEnd = async (item, newStatus, newIndex) => {
    if (!canChangeStatus) {
      message.error('У вас нет прав для изменения статуса вакансии');
      return;
    }
    
    try {
      await onStatusChange(item, newStatus, newIndex);
    } catch (error) {
      console.error('Ошибка при смене статуса:', error);
    }
  };

  const filteredStatuses = Object.keys(STATUSES)
    .filter(key => key !== 'template') // Исключаем статус "template" из канбана
    .reduce((acc, key) => {
      if (selectedStatuses.includes(key)) {
        acc[key] = {
          ...STATUSES[key],
          disabled: !canChangeStatus 
        };
      }
      return acc;
    }, {});


  const activeStatuses = Object.values(filteredStatuses).filter(status => !status.disabled);

  return (
    <>
      <Kanban
        items={vacancies}
        columns={filteredStatuses}
        onDragEnd={handleDragEnd}
        renderCard={renderCard}
      />
    </>
  );
};

export default KanbanView;